import React, {Component} from 'react';
import i18n from "../../../i18n";
import {
  withError,
  withStyleguide,
  withRouter,
  Loading, withJobInformationApi,
  FormUtility,
  GelContentContainer, Notices, HandleLoading
} from "cw-styleguide-react";
import ArticlesDetailView from "../views/ArticlesDetailView";
import {route} from "../../../routes";

class ArticlesDetailController extends Component {
  constructor(props) {
    super(props);
    this.state = {
      data:[],
      dataLoaded:false,
      messages:[]
    };
  }

  componentDidMount() {



    this.props.jobInformationApiGetArticle(this.props.params.article, i18n.language, (response) => {
      this.setState({
        data: response.data,
        dataLoaded: true
      });


      this.props.styleguide.setLanguageUrl(route('articles', null, i18n.language === 'en' ? 'cy' : 'en') + route('article', {article: response.data.slugTrans}, i18n.language === 'en' ? 'cy' : 'en'));

    }, (error) => {

      let errors = FormUtility.processServerErrors(error, i18n);
      if (error.response.status == 404) {
        this.setState({
          dataLoaded: error.response.status
        })
      } else {
        this.setState({
          messages: errors.messages,
          dataLoaded: false
        })
      }

    });

  }

  render() {

    return (
        <HandleLoading loading={{dataLoaded:this.state.dataLoaded}} messages={this.state.messages} container={true}>
      <ArticlesDetailView {...this.state}/>
        </HandleLoading>
    );
  }
}

export default withJobInformationApi(withRouter(withStyleguide(withError(ArticlesDetailController))));
